module.exports = __webpack_public_path__ + "static/media/metamaskLogo.be5dac0e.svg";